// src/modules/login/Login.jsx
import { FLASH_KEY } from '@app/utils/define';
import {userManager} from '@app/utils/oidc';
import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import { toast } from 'react-toastify';
// import './Login.scss';

const LoginSSO = () => {
    const {search} = useLocation();
    const [serverError, setServerError] = useState(null);

    // Bắt lỗi do server trả về ?error=invalid_credentials
    useEffect(() => {
        const params = new URLSearchParams(search);
        if (
            params.get('error') === 'invalid_credentials' &&
            serverError === null
        ) {
            setServerError('Sai tên đăng nhập hoặc mật khẩu.');
        }
    }, [search, serverError]);

    useEffect(() => {
        const raw = localStorage.getItem(FLASH_KEY);

        if (!raw) return;
        try {
            const { level = 'info', text = '' } = JSON.parse(raw);
            if (text) toast[level]?.(text);
        } catch {}
        localStorage.removeItem(FLASH_KEY);
    }, []);

    // Hàm khởi động flow OIDC
    const handleLogin = () => {
        userManager
            .signinRedirect() // Tự động build URL /connect/authorize?client_id=…&code_challenge=…&state=… :contentReference[oaicite:0]{index=0}
            .catch((err) => console.error('OIDC signinRedirect error', err));
    };

    document.getElementById('root').classList = 'hold-transition login-page';

    // Only changed the JSX returned below to improve UI theme per request
    return (
        <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #0d47a1 0%, #1976d2 50%, #64b5f6 100%)' }}>
            <div style={{ width: '100%', maxWidth: 1920, margin: '0 48px', borderRadius: 16, boxShadow: '0 12px 40px rgba(0,0,0,0.35)', overflow: 'hidden', display: 'flex', background: '#fff', minHeight: 320, gap: 48, padding: '2.5rem' }}>
                <div style={{ flex: '1 1 65%', padding: '2.5rem', background: 'linear-gradient(180deg, rgba(13,71,161,0.03), rgba(13,71,161,0.01))', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
                        <img src="/img/logo_benhvien_108.png" alt="Logo BV108" style={{ width: 250, height: 250, borderRadius: 12, objectFit: 'cover', boxShadow: '0 4px 16px rgba(13,71,161,0.18)' }} />
                        <div style={{ marginLeft: 16 }}>
                            <h1 style={{ margin: 0, color: '#0d47a1', fontSize: 36, letterSpacing: 0.5 }}>QUẢN LÝ CÔNG VIỆC</h1>
                            <div style={{ color: '#555', marginTop: 8, fontSize: 16 }}>Ban Công Nghệ Thông Tin</div>
                            <div style={{ marginTop: 12, color: '#777', fontSize: 13 }}>Nếu bạn gặp vấn đề khi đăng nhập, liên hệ với Ban CNTT.</div>
                        </div>
                    </div>
                </div>

                <div style={{ flex: '0 0 520px', padding: '3rem', background: '#fafafa', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' }}>
                    <div style={{ textAlign: 'center', marginBottom: 18 }}>
                        <h3 style={{ margin: 0, color: '#0d47a1' }}>Truy cập vào hệ thống</h3>
                        {/*<div style={{ color: '#666', marginTop: 6 }}>Sử dụng tài khoản công vụ của bạn</div>*/}
                    </div>

                    {serverError && (
                        <div className="alert alert-danger" role="alert" style={{ marginBottom: 16 }}>
                            {serverError}
                        </div>
                    )}

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                        <button
                            type="button"
                            className="btn btn-primary btn-block"
                            onClick={handleLogin}
                            style={{ padding: '0.95rem 1rem', fontSize: 16, borderRadius: 10, background: '#0d47a1', borderColor: '#0d47a1', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M22 12a10 10 0 0 0-10-10" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.6" /><path d="M12 7v5l3 3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                            <span>Kiểm tra đăng nhập</span>
                        </button>
                    </div>

                    <div style={{ marginTop: 28, textAlign: 'center', color: '#888', fontSize: 13 }}>
                        © {new Date().getFullYear()} Bệnh viện Trung ương Quân Đội 108
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginSSO;
